/**
 * frontend javascript swwapp campaign
 *
 * @package Wordpress/sww
 * @since 1.1.6
 * @version 1.0.0
 */

'use strict';

/* global jQuery */
/* global swwapp */
jQuery(function ($) {
  $(document).ready(function () {
    if ($('body.page-template-campaign').length === 1) {
      // Initialize Campaign-Object
      swwapp.campaign = {
        menuControl: $('.sww-campaign.menu-icon'),
        menuSlide: $('nav.sww-campaign.menu-wrap'),
        getMenuStatus: function getMenuStatus() {
          if ($(swwapp.campaign.menuControl).hasClass('open')) {
            return 'open';
          } else {
            return 'closed';
          }
        },
        // handle the clicks on the menu button
        menuClickHandler: function menuClickHandler(e) {
          var status = swwapp.campaign.getMenuStatus();
          switch (status) {
            case 'open':
              $(swwapp.campaign.menuControl).removeClass('open').addClass('closed');
              $(swwapp.campaign.menuSlide).removeClass('open').addClass('closed');
              break;
            case 'closed':
              $(swwapp.campaign.menuControl).removeClass('closed').addClass('open');
              $(swwapp.campaign.menuSlide).removeClass('closed').addClass('open');
              break;
          }
          return;
        },
        init: function init() {
          // bind a click-event to the menu-button
          $(swwapp.campaign.menuControl).on('click', swwapp.campaign.menuClickHandler);
        }
      };

      //Initiate swwapp.campaign
      swwapp.campaign.init();
    }
  });
});